<template>
  <div id="time-control" @click.capture="closeEffectPopup()">
    <div class="time-buttons">
      <div class="scale-tool">
        <span class="reduce">
          <i
            class="el-icon-minus"
            style="font-weight: bold"
            @click.self="setScale(-25)"
          ></i>
        </span>
        <span class="proportion">{{
          TOOL && TOOL.option.scale * 100 + "%"
        }}</span>
        <span class="increase">
          <i
            class="el-icon-plus"
            style="font-weight: bold"
            @click.self="setScale(25)"
          ></i>
        </span>
      </div>
      <div class="play-info">
        <div
          class="play-button"
          @click.stop="scenesPlay()"
          @mousedown.stop="closeModal"
          @mouseover="showPopover = true"
          @mouseout="showPopover = false"
        >
          <i :class="isPlay ? 'pause' : 'play'"></i>
          <transition name="popover">
            <div class="popover-box" v-show="showPopover">
              <div class="top-arrow"></div>
              预览当前页面
            </div>
          </transition>
        </div>
        <div>
          <div class="now-time">{{ (nowTimes + nowTime) | formatTime }}</div>
          <span>/</span>
          <div class="total-time">{{ allTime | formatTime }}</div>
        </div>
        <div class="limit-tip-wrapper">
          <limit-tip></limit-tip>
        </div>
      </div>
      <div class="show-hide">
        <!-- <div>时间轴</div>
        <el-switch v-model="timelineStatus" @change="showOrHide"></el-switch>
        <div class="bgm" @click="showVolume" v-analysis="ANALYSIS.soundManage">
          <span style="margin: 0 10px 0 5px">|</span>
          <span>
            声音
            <i class="music-icon"></i>
          </span>
        </div> -->
        <el-popover
          placement="top"
          trigger="hover"
          popper-class="staff-popover"
          :visible-arrow="false"
        >
          <div class="qrCode">
            <div class="word">扫码立即线上沟通</div>
            <div class="content">
              <img class="content-img" :src="QRImage" alt="">
            </div>
          </div>
          <div slot="reference" class="support-staff" @click-x="showSupportStaff">
            <div class="icon"></div>
          </div>
        </el-popover>
      </div>
    </div>
    <div v-show="timelineStatus" class="time-line">
      <div class="time-line-body">
        <div class="timeline-axis">
          <div class="timeline-axis-content">
            <div
              class="content-box"
              v-for="n in totalTime * 2 + 1"
              :style="{
                width: 50 / totalTime + '%',
                left: (50 / totalTime) * (n - 1) + '%',
              }"
            >
              <span v-show="n % 2" class="every-text">{{
                (n - 1) / 2 + "s"
              }}</span>
              <!-- <span class="every-axis"></span> -->
            </div>
          </div>
          <div class="rc-slider">
            <el-tooltip
              effect="dark"
              content="移动小三角，可查看视频的每个画面"
              placement="top"
              :open-delay="2000"
            >
              <div
                v-dragHandle
                class="rc-slider-handle"
                :style="{ left: (nowTime / totalTime) * 100 + '%' }"
                @mouseup="$bus.emit('userTaskStep', {source: 'timeline'})"
              >
                <img
                  src="./../../assets/handle.svg"
                  ondragstart="return false;"
                />
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="timeline-container">
          <v-selection
            :totalTime="totalTime"
            :nowTime.sync="nowTime"
          ></v-selection>
          <v-camera :totalTime="totalTime"></v-camera>
        </div>
        <div
          v-dragFlags
          class="timeline-flags"
          :style="{ width: Tool_Size.width - 84 + 'px' }"
        >
          <div class="sprite-flag" v-for="spriteObject in spritesContent">
            <sprites-flag
              :spriteObject="spriteObject"
              :spritesContent.sync="spritesContent"
              :nowTime.sync="nowTime"
              :totalTime="totalTime"
              :timelineWidth="Tool_Size.width - 84"
            ></sprites-flag>
          </div>
        </div>
      </div>
      <div class="time-line-button">
        <el-tooltip
          effect="dark"
          :content="`${
            totalTime < 20
              ? '添加时间'
              : '每页最多可添加时长20秒的视频。您也可以在下一页继续创作。'
          }`"
          placement="top"
          :open-delay="1000"
        >
          <i
            @click.self="changeTotalTime(1, true)"
            v-analysis="ANALYSIS.addSwitch"
            >+</i
          >
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="减少时间"
          placement="top"
          :open-delay="1000"
        >
          <i
            @click.self="changeTotalTime(-1, true)"
            v-analysis="ANALYSIS.minusSwitch"
            >-</i
          >
        </el-tooltip>
      </div>
      <div class="time-line-help" @click="$modal.show('timelineTutorial')">
        <!-- <a
          target="_blank"
          :href="
            $getWikiLink(
              'https://wiki.laihua.com/basic/shijianzhou/shijianzhou.html'
            )
          "
        >?</a> -->
        <span>?</span>
      </div>
    </div>
  </div>
</template>
<script>
import spritesFlag from "./timeline/spritesFlag.vue";
import selection from "./timeline/selection.vue";
import cameraTime from "./timeline/cameraTime.vue";
import limitTip from "./timeline/limitTip.vue";
import { mapGetters } from "vuex";
import durationLimitMixin from "../tool/timeline/limitMixin.vue";

export default {
  mixins: [durationLimitMixin],
  computed: {
    ...mapGetters([
      "TOOL",
      "Tool_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "SetPanel_Size",
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "UserEquity", // 用户权益
      "cameras",
      "isPreventDefault",
      "UserMsg",
      "subtitle/subtitleEditor",
      'UserLevelInfo'
    ]),
    ...mapGetters({
      soundHandle: "addSoundtrack/getPlayHandle",
    }),
  },
  data() {
    return {
      ANALYSIS: {
        preview: {
          category: "editor_others",
          action: "click_local_preview",
          label: "编辑器其他_局部预览",
        },
        openSwitch: {
          category: "editor_time_axis",
          action: "click_open_switch",
          label: "编辑器_时间轴_开启",
        },
        closeSwitch: {
          category: "editor_time_axis",
          action: "click_close_switch",
          label: "编辑器_时间轴_关闭",
        },
        addSwitch: {
          category: "editor_time_axis",
          action: "click_add_switch",
          label: "编辑器_时间轴_增加时长",
        },
        minusSwitch: {
          category: "editor_time_axis",
          action: "click_minus_switch",
          label: "编辑器_时间轴_缩减时长",
        },
        sinDrag: {
          category: "axis_enter_animation_setting",
          action: "drag_enter_ani_thumb_sin_ele",
          label: "拖拽_时间轴_入场素材缩略图_单素材",
        },
        multiDrag: {
          category: "axis_enter_animation_setting",
          action: "drag_enter_ani_thumb_muti_ele",
          label: "拖拽_时间轴_入场素材缩略图_多素材",
        },
        soundManage: {
          category: "editor_sound_management",
          action: "click_sound_management",
          label: "编辑器_声音管理",
        },
      },
      showPopover: false,
      timelineStatus: true, // 时间轴状态
      spritesContent: {}, // 元素按照入场时间分组的对象
      totalTime: 10, // 总时间
      nowTime: 1, // 当前时间
      nowTimePlay: 0, // 点击播放时的时间
      selected: true, // 是否有选中的元素，生成梯形条
      dragHandle: false, // 是否隐藏播放层
      isPlay: false, // 是否在播放
      changeWidth: false,
      noPlay: false, // 更新nowTime不播放
      isShowPlay: false, // 播放层是否显示
      allTime: 0, // 视频总时长
      nowTimes: 0, // 应该在的时长
      isTotalPlay: false, // 是否在进行全局播放
      previewSource: "", // 单独预览某段时间的来源
      spriteBox: null,
      animFrame: null,
      QRImage: ''
    };
  },
  created () {
    eve.on('editor.scenesAdded', () => {
      this.emitDurationLimit();
    });
    eve.on('editor.scenesRemoved', () => {
      this.emitDurationLimit();
    });
    this.getQRData();
  },
  mounted() {
    if (!this.SelectScenes_Msg) {
      this.totalTime = 10;
    } else {
      this.totalTime = this.SelectScenes_Msg.getDuration() / 1000;
    }
    this.$store.commit("save_TimeLine", { height: 172 });
    this.$bus.on("spritesFlagChange", (data) => {
      this.getSpritesContent();
    });
    this.$bus.on("spritesFlagTime", (data) => {
      // flag 拖动三角拖块需要跟着
      if (data.enterTime > this.nowTime * 1000) {
        this.nowTime = data.enterTime / 1000;
        this.noPlay = true;
      } else if (data.enterTime < 0) {
        this.nowTime = 0;
        this.noPlay = true;
      }
      if (data.exitTime < this.nowTime * 1000) {
        this.nowTime = data.exitTime / 1000;
        this.noPlay = true;
      }
    });
    this.$bus.on("timeline_play_stop", (data) => {
      if (!data.isPlay && this.isPlay) {
        this.scenesPlay();
      }
    });
    this.$bus.on("windowMousedown_vue", () => {
      if (this.isPlay) {
        this.scenesPlay();
      }
    });
    eve.on("timeline_nowTime_change", (data) => {
      if (!data.nowTime) return;
      this.noPlay = !!data.noPlay;
      if (data.nowTime > this.totalTime) {
        this.nowTime = this.totalTime - 0.5;
      } else {
        this.nowTime = data.nowTime;
      }
    });
    eve.on("totalTime_danger-x", data => {
      if (this.UserMsg.level > 0) {
        // this.$bus.emit("FeaturesPop_vue", {
        //   name: "vipEquity",
        //   msg: "您最多只能输出3分钟的视频，开通企业会员，视频时长无限制",
        //   btnMsg: "立即开通",
        //   btnMsgLink: "/vip",
        //   type: 2,
        //   levelType: "vip"
        // });
        this.$modal.show("vipDialog", {
          msg: "您最多只能输出3分钟的视频，开通企业会员，视频时长无限制",
          target: "vip",
          type: "vip.s",
        });
      } else {
        // this.$bus.emit("FeaturesPop_vue", {
        //   name: "vipEquity",
        //   msg: "您最多只能输出一分半钟的视频，升级个人VIP，可延长至3分钟",
        //   btnMsg: "立即开通",
        //   btnMsgLink: "/vipsolo",
        //   recommendVip: "视频时长无限制，点击了解高级会员",
        //   type: 2
        // });
        this.$modal.show("vipDialog", {
          msg: "您最多只能输出一分半钟的视频，升级个人VIP，可延长至3分钟",
          target: "vipsolo",
          type: "solo",
          bottomLink: "/vip",
          bottomLinkText: "视频时长无限制，点击了解高级会员",
        });
      }
    });

    this.$bus.on("materialPane_vue", (data) => {
      if (!this.timelineStatus && data.type !== "sound" && data.type !== "bg") {
        this.timelineStatus = true;
        this.showOrHide();
      }
    });
    this.$bus.on("undoRedoHandle", (data) => {
      if (data.type === "changeTotalTime") {
        this.totalTime = this.SelectScenes_Msg.getDuration() / 1000;
        this.getSpritesContent();
      }
    });
    this.$bus.on("timeline_update_totaltime", () => {
      let times = this.getTimes();
      this.allTime = times[0];
      this.totalTime = this.SelectScenes_Msg.getDuration() / 1000;
    });
    this.$bus.on("Modal_vue", (data) => {
      data.name === "preview" && (this.isTotalPlay = true);
    });
    this.$bus.on("Modal_close_vue", (data) => {
      data.name === "preview" && (this.isTotalPlay = false);
    });
    this.$bus.on("preview_callback", (data) => {
      if (data.type === "play") {
        this.spriteBox = data.spriteBox;
        this.scenesPlay(data.startNode, data.stopNode);
        this.previewSource = data.source;
      } else {
        this.spriteBox = null;
      }
    });
    this.$bus.on("keycode_space", (data) => {
      if (data.shortcutType === "editor" || data.shortcutType === "camera") {
        if (
          (this.SelectSprites_Msg.length >= 1 &&
            this.SelectSprites_Msg[0].action) ||
          this.isTotalPlay
        )
          return;
        this.scenesPlay();
      }
    });
    this.$bus.on("bgZoom.playScene", () => {
      this.nowTime = 0;
      if (this.isPlay) {
        this.scenesPlay(0);
      }
      setTimeout(() => {
        this.scenesPlay(0);
      }, 50);
    });
  },
  watch: {
    allTime(nv) {
      if (this.soundHandle.musicLoop) {
        this.$store.commit("addSoundtrack/updateMusic", {
          music: {
            timeSlot: [0, nv],
          },
          index: 0,
        });
      }
      if (window.infoBeforeCrash) {
        window.infoBeforeCrash.draftDuration = nv;
      }
    },
    "SelectScenes_Msg.sprites": function (val, oldval) {
      // 改变场景元素，重新计算spitesContent
      this.getSpritesContent();
    },
    "Tool_Size.width": function (val, oldval) {
      this.resizeWidth();
    },
    "SelectScenes_Msg.id": function (val, oldval) {
      if (!this.SelectScenes_Msg) {
        this.totalTime = 10;
      } else {
        this.totalTime = this.SelectScenes_Msg.getDuration() / 1000;
        // 每个分组的当前时间
        this.nowTime =
          this.SelectScenes_Msg.nowTime === undefined
            ? 1
            : this.SelectScenes_Msg.nowTime;
        this.noPlay = true;
      }
    },
    nowTime(val, oldval) {
      // 三角拖块变化后，动画实现
      if (!this.SelectScenes_Msg.sprites && !this.SelectScenes_Msg.id) return;
      this.SelectScenes_Msg.nowTime = val;
      let frame = Math.ceil(this.nowTime * 60);
      // 解决最后一帧元素不见的问题
      // if(this.nowTime >= this.totalTime) frame--;
      // eve('playByFrame', null, frame, this.SelectScenes_Msg.id)
      this.TOOL.eve.emit("playByFrame", frame, this.SelectScenes_Msg.id);
      this.TOOL.eve.emit("play_" + this.SelectScenes_Msg.id, frame);
      this["subtitle/subtitleEditor"] &&
        this["subtitle/subtitleEditor"].playing(this.nowTimes * 60 + frame);
      this.isShowPlay = true;
      if (!this.dragHandle && !this.isPlay) {
        this.TOOL.cancelPlay();
        // 同步路径动画对应时间点位置
        this.syncPathOffset(val);
        this.isShowPlay = false;
        // 选择路径动画时，播放结束隐藏元素
        this.SelectSprites_Msg.length === 1 &&
          this.SelectSprites_Msg[0].effect.pathAnim.end &&
          this.SelectSprites_Msg[0].showHideSpriteDom(false);
      }
    },
    "SelectScenes_Msg.duration": function (val, oldval) {
      let times = this.getTimes();
      this.allTime = times[0];
      this.nowTimes = times[1];
    },
    "SelectScenes_Msg.index": function (val, oldval) {
      let times = this.getTimes();
      this.allTime = times[0];
      this.nowTimes = times[1];
    },
    "TOOL.sprites.length" () {
      let times = this.getTimes();
      this.allTime = times[0];
      this.nowTimes = times[1];
    }
  },
  methods: {
    getQRData (id) {
      const levelCode = this.UserLevelInfo.levelCode || 0;
      const trial = this.UserLevelInfo.trial;
      const isEnterprise = levelCode >= 2 && !trial;
      id = isEnterprise ? '1689469857361592321' : '1689197785469190144';
      return new Promise(resolve => {
        wlQrcodeCustomComp.getQrCodeUrl(
          { wl_qrcode_id: id,},
          (data) => {
            console.log(`Turbo ~ getQRData ~ data`, data)
            localStorage.setItem('qrCode1',data.data.qr_code)
            this.QRImage = data.data.qr_code
            resolve(data);
          },
        );
      })
    },
    showVolume() {
      this.$bus.emit("FeaturesPop_vue", {
        name: "volume_adjust",
        posx: 0,
        posy: 0,
        type: 1,
        BGM: this.BGM,
      });
    },
    showOrHide() {
      // 时间轴的隐藏和显示
      if (this.timelineStatus) {
        this.$store.commit("save_TimeLine", { height: 172 });
        // 弹出气泡提示
        this.$bus.emit("showTips", {
          text: "点击“+”或“-”可修改每一页的时间，每页最长的动画时间为20秒。",
          position: {
            bottom: "160px",
            right: `${this.SetPanel_Size.width - 15}px`,
          },
        });
      } else {
        this.$store.commit("save_TimeLine", { height: 72 });
      }
      this.$analysis(
        this.timelineStatus
          ? this.ANALYSIS.openSwitch
          : this.ANALYSIS.closeSwitch
      );
      this.$bus.emit("EditorSetOption_vue", {
        data: true,
        source: "timeline",
      });
    },
    getSpritesContent() {
      // 生成按入场时间的数组
      let spritesAll = this.SelectScenes_Msg.sprites,
        spriteContent = {},
        spritesContent = [],
        spriteData = {};
      this.spritesContent = [];
      for (let i = 0, len = spritesAll.length; i < len; i++) {
        if (spritesAll[i].effect) {
          let j = (spritesAll[i].effect.entranceAnim.end / 1000).toFixed(1);
          if (!spriteContent[j]) {
            spriteContent[j] = [].concat(spritesAll[i]);
          } else {
            spriteContent[j] = spriteContent[j].concat(spritesAll[i]);
          }
        }
      }
      for (let key in spriteContent) {
        if (spriteContent.hasOwnProperty(key)) {
          spriteData.enterTime = +key * 1000;
          spriteData.sprites = spriteContent[key];
          spriteData.len = spriteContent[key].length;
          spritesContent.push(spriteData);
          spriteData = {};
        }
      }
      this.spritesContent = [].concat(spritesContent);
      this.resizeWidth();
    },
    changeTotalTime(val, undo) {
      // 总时间的加减  --->TODO
      let change = 0;
      let changeData = {
          sprites: [],
          cameras: [],
        },
        timeAll = this.TOOL.getDuration(),
        info = null;
      if (val > 0) {
        if (this.totalTime >= 20) {
          console.log(`Turbo ~ changeTotalTime ~ this.totalTime`, this.totalTime)
          this.$bus.emit('clickTimelinePlusExceeded')
          return;
        } else {
          // if (this.UserEquity.time && timeAll > this.UserEquity.time) {
          //   eve("totalTime_danger", null, { timeAll: timeAll });
          //   // return;
          // }
          // this.emitDurationLimit();
          let sprites = this.SelectScenes_Msg.sprites;
          for (let i = 0; i < sprites.length; i++) {
            let exit = sprites[i].effect.exitAnim;
            if (this.totalTime * 1000 - exit.end < 0.001) {
              info = {
                id: sprites[i].id,
                way: "updateEffect",
                reData: {
                  exitAnim: {
                    start: exit.start,
                    end: exit.end,
                  },
                },
                data: {
                  exitAnim: {
                    start: exit.start + 500,
                    end: exit.end + 500,
                  },
                },
              };
              changeData.sprites.push(info);
              sprites[i].updateEffect({
                exitAnim: {
                  start: exit.start + 500,
                  end: exit.end + 500,
                },
              });
            }
          }
          this.totalTime += 0.5;
          change = 0.5;
          this.resizeWidth();
        }
      } else {
        if (this.totalTime <= 1) {
          return;
        } else {
          // this.emitDurationLimit();
          this.totalTime -= 0.5;
          change = -0.5;
          if (this.nowTime >= this.totalTime) {
            this.nowTime = this.totalTime;
          }
          changeData.sprites = this.forPlusTotalTime();
          changeData.cameras = this.lensPlusTime();
          this.getSpritesContent();
        }
      }
      if (undo && change !== 0) {
        eve("undo_redo", null, {
          type: "changeTotalTime",
          data: {
            scenesId: this.SelectScenes_Msg.id,
            change: change,
            changeData: changeData,
          },
        });
      }
      if (change !== 0) {
        const data = [this.nowTimes + this.totalTime - change, change, timeAll];
        this.soundHandle.changeScenesTime(...data);
        this.$store.commit("subtitle/changeScenesTime", data);
      }
      this.SelectScenes_Msg.setDuration(this.totalTime * 1000);
      this.emitDurationLimit();
    },
    forPlusTotalTime() {
      if (!this.SelectScenes_Msg.sprites) return [];
      let sprites = this.SelectScenes_Msg.sprites,
        exitAnim = [],
        entranceAnim = null,
        pathAnim = null,
        change = [],
        info = null;
      for (let i = 0; i < sprites.length; i++) {
        if (sprites[i].effect.pathAnim.end) {
          pathAnim = {
            start: sprites[i].effect.pathAnim.start,
            end: sprites[i].effect.pathAnim.end,
          };
        } else {
          pathAnim = null;
        }

        if (sprites[i].effect.exitAnim.end >= this.totalTime * 1000 + 1000) {
          if (
            sprites[i].effect.exitAnim.start -
              sprites[i].effect.entranceAnim.end <
            0.001
          ) {
            if (pathAnim) {
              pathAnim = {
                start: sprites[i].effect.entranceAnim.end - 1000,
                end: sprites[i].effect.entranceAnim.end - 500,
              };
            }
            entranceAnim = {
              start: sprites[i].effect.entranceAnim.start - 1000,
              end: sprites[i].effect.entranceAnim.end - 1000,
            };
            exitAnim = {
              start: sprites[i].effect.exitAnim.start - 1000,
              end: sprites[i].effect.exitAnim.end - 1000,
            };
          } else if (
            sprites[i].effect.exitAnim.start -
              sprites[i].effect.entranceAnim.end <
            500.001
          ) {
            if (pathAnim) {
              pathAnim = {
                start: sprites[i].effect.entranceAnim.end - 500,
                end: sprites[i].effect.entranceAnim.end,
              };
            }
            entranceAnim = {
              start: sprites[i].effect.entranceAnim.start - 500,
              end: sprites[i].effect.entranceAnim.end - 500,
            };
            exitAnim = {
              start: sprites[i].effect.exitAnim.start - 1000,
              end: sprites[i].effect.exitAnim.end - 1000,
            };
          } else {
            if (
              pathAnim &&
              pathAnim.end > sprites[i].effect.exitAnim.start - 1000
            ) {
              pathAnim.end = sprites[i].effect.exitAnim.start - 1000;
              if (pathAnim.end - sprites[i].effect.entranceAnim.end < 0.001) {
                pathAnim.end += 500;
              }
            }
            exitAnim = {
              start: sprites[i].effect.exitAnim.start - 1000,
              end: sprites[i].effect.exitAnim.end - 1000,
            };
          }
        } else if (
          sprites[i].effect.exitAnim.end >=
          this.totalTime * 1000 + 500
        ) {
          if (
            sprites[i].effect.exitAnim.start -
              sprites[i].effect.entranceAnim.end <
            0.001
          ) {
            if (pathAnim) {
              pathAnim = {
                start: sprites[i].effect.entranceAnim.end - 500,
                end: sprites[i].effect.entranceAnim.end,
              };
            }
            entranceAnim = {
              start: sprites[i].effect.entranceAnim.start - 500,
              end: sprites[i].effect.entranceAnim.end - 500,
            };
            exitAnim = {
              start: sprites[i].effect.exitAnim.start - 500,
              end: sprites[i].effect.exitAnim.end - 500,
            };
          } else {
            if (
              pathAnim &&
              pathAnim.end > sprites[i].effect.exitAnim.start - 500
            ) {
              pathAnim.end = sprites[i].effect.exitAnim.start - 500;
              if (pathAnim.end - sprites[i].effect.entranceAnim.end < 0.001) {
                pathAnim.end += 500;
              }
            }
            exitAnim = {
              start: sprites[i].effect.exitAnim.start - 500,
              end: sprites[i].effect.exitAnim.end - 500,
            };
          }
        }

        if (entranceAnim || exitAnim) {
          info = {
            id: sprites[i].id,
            way: "updateEffect",
            reData: {
              entranceAnim: {
                start: sprites[i].effect.entranceAnim.start,
                end: sprites[i].effect.entranceAnim.end,
              },
              exitAnim: {
                start: sprites[i].effect.exitAnim.start,
                end: sprites[i].effect.exitAnim.end,
              },
              pathAnim: pathAnim
                ? {
                    start: sprites[i].effect.pathAnim.start,
                    end: sprites[i].effect.pathAnim.end,
                  }
                : null,
            },
            data: {
              entranceAnim: entranceAnim,
              exitAnim: exitAnim,
              pathAnim: pathAnim,
            },
          };
          change.push(info);
          sprites[i].updateEffect({
            entranceAnim: entranceAnim,
            exitAnim: exitAnim,
            pathAnim: pathAnim,
          });
          entranceAnim = null;
          exitAnim = null;
          pathAnim = null;
        }
      }

      return change;
    },
    lensPlusTime() {
      let cameras = this.SelectScenes_Msg.camera.cameras;
      let last = cameras.length - 1;
      if (last === 0) return [];
      let change = [];
      for (let i = 0; i < 2; i++) {
        let anim = Object.assign({}, cameras[last - i].animations);
        anim.end = anim.delay + anim.duration;
        if (anim.delay < this.totalTime && anim.end <= this.totalTime) {
          return change;
        } else if (anim.delay < this.totalTime && anim.end > this.totalTime) {
          change.push({
            index: last - i,
            way: "update",
            reData: {
              delay: anim.delay,
              duration: anim.duration,
            },
            data: {
              delay: anim.delay,
              duration: this.totalTime - anim.delay,
            },
          });
          this.SelectScenes_Msg.camera.updateCamera(last - i, {
            animations: {
              delay: anim.delay,
              duration: this.totalTime - anim.delay,
            },
          });
          return change;
        } else if (anim.delay >= this.totalTime) {
          change.push({
            index: last - i,
            way: "delete",
            reData: $.extend(true, {}, cameras[last - i]),
          });
          this.SelectScenes_Msg.camera.delCamera(last - i);
        }
      }
      return change;
    },
    scenesPlay(startNode, stopNode) {
      this.$bus.emit("stop_listen_BGM");
      // 分组播放
      let start = null,
        step = null;

      if (!this.isPlay) {
        // 埋点
        this.$analysis(this.ANALYSIS.preview);
        this.TOOL.selectSprite();
        this.nowTimePlay = this.nowTime;
        if (this.TOOL.option.scale !== 1) {
          this.TOOL.setOption({
            width: this.Tool_Size.width,
            height: this.Tool_Size.height - 40,
            scale: 1,
            surplusY: this.TopNav_Size.height + 40,
            surplusX: this.MaterialPane_Size.width,
          });
        }

        // 从当前位置播放
        startNode === undefined &&
          (startNode = this.nowTime >= this.totalTime ? 0 : this.nowTime);

        this.TOOL.player.maskEle.children().hide();
        this.SelectScenes_Msg && this.SelectScenes_Msg.effect.init();
        this.SelectScenes_Msg.index - 1 >= 0 &&
          this.TOOL.sprites[this.SelectScenes_Msg.index - 1].effect.init();
      }
      this.isPlay = !this.isPlay;
      this.$bus.emit("timeline_play_scenes", {
        nowTime: startNode,
        isPlay: this.isPlay,
        forWater: this.isPlay,
        time: this.nowTimes + startNode,
      });

      step = (timestamp) => {
        if (!this.isPlay) {
          window.cancelAnimationFrame(this.animFrame);
          this.nowTime = Math.round(this.nowTime * 2) / 2;
          return;
        }
        let progress = 0;
        if (!start) start = timestamp;
        progress = (timestamp - start) / 1000;
        this.nowTime = progress + startNode;
        if (stopNode && this.nowTime >= stopNode) {
          window.cancelAnimationFrame(this.animFrame);
          this.isPlay = false;
          // 路径动画正常预览结束事件
          this.TOOL.selectSprite([this.spriteBox]);
          this.$bus.emit("FeaturesPop_vue", {
            type: 1,
            name: "effectSetting",
            sprite: this.spriteBox,
            contentType: this.previewSource,
          });
          this.$bus.emit("timeline_play_scenes", {
            nowTime: this.nowTime,
            isPlay: this.isPlay,
            forWater: this.isPlay,
            time: this.nowTimes + this.nowTime,
          });
          return;
        }
        if (this.nowTime < this.totalTime) {
          this.animFrame = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(this.animFrame);
          this.nowTime = this.totalTime;
          this.isPlay = false;
          this.$bus.emit("timeline_play_scenes", {
            nowTime: this.nowTime,
            isPlay: this.isPlay,
            forWater: this.isPlay,
            time: this.nowTimes + this.nowTime,
          });
        }
      };

      this.animFrame = window.requestAnimationFrame(step);
    },
    resizeWidth() {
      if ((this.Tool_Size.width - 84) / this.totalTime / 2 < 30) {
        this.changeWidth = false;
        this.$bus.emit("flag_resize_width", { enterTime: false });
        let arr = [].concat(this.spritesContent);
        arr.sort((a, b) => {
          return a.enterTime - b.enterTime;
        });

        for (let i = 0; i < arr.length - 1; i++) {
          if (arr[i + 1].enterTime - arr[i].enterTime === 500) {
            this.changeWidth = true;
            let timeout = setTimeout(() => {
              clearTimeout(timeout);
              timeout = null;
              this.$bus.emit("flag_resize_width", {
                enterTime: [arr[i].enterTime, arr[i + 1].enterTime],
              });
            });
          }
        }
      } else {
        if (this.changeWidth) {
          this.changeWidth = false;
          this.$bus.emit("flag_resize_width", { enterTime: false });
        }
      }
    },
    closeEffectPopup() {
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "inOutEffect",
        type: 1,
      });
    },
    setScale(val) {
      if (!this.TOOL.option.scale) return;

      let scale = 1;

      scale = this.TOOL.option.scale * 100 + val;
      if (scale < 50) {
        scale = 50;
      } else if (scale > 150) {
        scale = 150;
      }
      this.TOOL.setOption({
        width: this.Tool_Size.width,
        height: this.Tool_Size.height - 40,
        scale: scale / 100,
        surplusY: this.TopNav_Size.height + 40,
        surplusX: this.MaterialPane_Size.width,
      });
    },
    closeModal() {
      this.$bus.emit("FeaturesPop_close_vue", {
        type: 3,
      });
    },
    getTimes() {
      let times = [0, 0];
      if (!this.TOOL) return;
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        if (this.SelectScenes_Msg.index === i) times[1] = times[0];
        times[0] += this.TOOL.sprites[i].duration;
      }
      times[0] /= 1000;
      times[1] /= 1000;
      return times;
    },
    syncPathOffset(time) {
      if (this.SelectScenes_Msg.fromJsonLoadingState === 2) {
        this.SelectScenes_Msg.sprites.forEach((sprite) => {
          sprite.syncPathOffset(time);
        });
      }
    },
    showSupportStaff () {
      this.$store.dispatch('showServiceChat');
    }
  },
  components: {
    "sprites-flag": spritesFlag,
    "v-selection": selection,
    "v-camera": cameraTime,
    "limit-tip": limitTip,
  },
  directives: {
    dragHandle(el, binding, vnode) {
      let _this = vnode.context,
        nowTime = 0,
        mousemove = null,
        mouseup = null,
        disx = 0;

      mousemove = (e) => {
        e.preventDefault();
        // 拖动改变时间
        var pre =
          ((disx - e.pageX) / (_this.Tool_Size.width - 84)) * _this.totalTime;
        _this.nowTime =
          nowTime - pre < 0
            ? 0
            : nowTime - pre > _this.totalTime
            ? _this.totalTime
            : nowTime - pre;
      };

      mouseup = (e) => {
        e.preventDefault();
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
        // 防止拖到0s的时候没有执行关闭播放层的BUG
        if (_this.isShowPlay) {
          _this.TOOL.cancelPlay();
        }
        _this.dragHandle = false;
        _this.nowTime = Math.round(_this.nowTime * 2) / 2;
      };

      el.onmousedown = (e) => {
        e.preventDefault();
        _this.dragHandle = true;
        nowTime = _this.nowTime;
        disx = e.pageX;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        // 给每个元素effect.init()
        _this.TOOL.player.maskEle.children().hide();
        _this.SelectScenes_Msg && _this.SelectScenes_Msg.effect.init();
        _this.SelectScenes_Msg.index - 1 >= 0 &&
          _this.TOOL.sprites[_this.SelectScenes_Msg.index - 1].effect.init();
        // 拖动三角拖块，取消选中
        if (_this.SelectSprites_Msg && _this.SelectSprites_Msg.length > 0) {
          _this.TOOL.selectSprite(null);
        }
      };
    },
    dragFlags(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        disx = 0,
        dataId = "";

      mousemove = (e) => {
        let dx = e.pageX - disx;
        _this.$bus.emit("dragsFlags", { type: "move", dx: dx, dataId: dataId });
      };

      mouseup = (e) => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
        _this.SelectSprites_Msg.length &&
          _this.$analysis(
            _this.SelectSprites_Msg.length >= 2
              ? _this.ANALYSIS.multiDrag
              : _this.ANALYSIS.sinDrag
          );
        _this.$bus.emit("dragsFlags", { type: "up", dataId: dataId });
      };

      el.onmousedown = (e) => {
        e.preventDefault();
        // e.stopPropagation();

        (disx = e.pageX), (dataId = e.target.dataset.id);

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.isPlay && _this.scenesPlay();

        _this.$bus.emit("dragsFlags", { type: "down", dataId: dataId });
      };
    },
  },
  filters: {
    formatTime(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.floor(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      if (duration % 60 % 1 > 0) {
        sec += '.5'
      }
      return min + ":" + sec;
    },
  },
};
</script>

<style lang="scss">
#time-control {
  position: relative;
  z-index: 130;
  padding-bottom: 8px;
  background: linear-gradient(
    to bottom,
    rgba(240, 241, 248, 0.75),
    #eff1f8 30%
  );
}

.time-line {
  width: 100%;
  height: 92px;
  display: flex;
  padding: 0 30px;
  box-sizing: border-box;
  * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
@media (max-width: 1560px) {
  .time-buttons .play-info {
    position: relative;
  }
  .time-buttons .play-info .limit-tip-wrapper {
    position: absolute;
    left: 46px;
    top: -28px;
  }
}
.time-buttons {
  display: flex;
  height: 72px;
  padding: 0 30px;
  justify-content: space-between;
  align-items: center;

  .scale-tool {
    display: flex;
    width: 114px;
    justify-content: space-between;

    .proportion {
      display: inline-block;
      width: 68px;
      height: 20px;
      color: #424f61;
      line-height: 20px;
      text-align: center;
      font-size: 13px;
    }

    .reduce,
    .increase {
      display: inline-block;
      width: 20px;
      height: 20px;
      background-color: #ffffff;
      border-radius: 2px;
      color: #979fa9;
      font-weight: bold;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }

  .play-info {
    display: flex;
    justify-content: space-between;
    width: 140px;
    margin-left: 90px;

    > div {
      display: flex;
    }

    span,
    .now-time,
    .total-time {
      line-height: 42px;
      color: #474261;
    }
    .now-time {
      margin-left: 20px;
    }
    .limit-tip-wrapper {
      display: flex;
      align-items: center;
      margin-left: 16px;
    }
  }

  .play-button {
    position: relative;
    width: 42px;
    height: 42px;
    cursor: pointer;
    outline: none;

    i {
      display: block;
    }

    i.play {
      width: 40px;
      height: 40px;
      background: url("../../../static/svg/play.svg") no-repeat center;
      &:hover,
      &:active {
        background: url("../../../static/svg/play-active.svg") no-repeat center;
      }
    }

    i.pause {
      width: 40px;
      height: 40px;
      background-color: #fff;
      background: url("../../../static/svg/pause.svg") no-repeat center;
      &:hover,
      &:active {
        background: url("../../../static/svg/pause-active.svg") no-repeat center;
      }
    }
    .popover-box {
      display: block;
      position: absolute;
      padding: 10px;
      top: 52px;
      left: -35px;
      height: 40px;
      z-index: 2001;
      margin: 0;
      background: #303133;
      width: 104px;
      color: #fff;
      line-height: 1.4;
      text-align: justify;
      font-size: 14px;
      border-radius: 4px;
      .top-arrow {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        top: -6px;
        left: 49px;
        margin-bottom: 3px;
        border-width: 6px;
        border-top-width: 0;
        border-bottom-color: #303133;
      }
    }
  }
  .popover-enter-active {
    transition: all 0.3s linear 1s;
  }
  .popover-leave-active {
    transition: all 0s linear;
  }
  .popover-enter,
  .popover-leave-to {
    opacity: 0;
  }
  .popover-enter-to,
  .popover-leave {
    opacity: 1;
  }
  .show-hide {
    display: flex;
    justify-content: flex-end;
    width: 138px;

    > div:first-child {
      margin-right: 8px;
      font-size: 14px;
      color: #424f61;
    }

    > div:last-child {
      margin-left: 5px;
      font-size: 14px;
      color: #424f61;
    }

    .is-checked .el-switch__core {
      border-color: #5778fb;
      background-color: #5778fb;
    }

    .bgm {
      display: flex;
      cursor: pointer;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .music-icon {
        margin-left: 10px;
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url("../../../static/svg/music.svg") no-repeat center;
      }
    }
  }
}

.time-line-body {
  width: 100%;
}

.timeline-axis {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 4px;
  position: relative;
  margin: 20px 0 1px 0;
  padding: 0;

  .timeline-axis-content {
    width: 100%;
    height: 100%;
    position: absolute;
    padding: 0;
    bottom: 0;
    left: 0;

    .content-box {
      border-left: 1px solid #6a7584;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 100%;
      position: absolute;
      cursor: pointer;

      .every-text {
        position: absolute;
        top: -19px;
        left: 0;
        color: #8f8ba9;
        width: 100%;
        text-align: center;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        font-size: 12px;
      }

      .every-axis {
        display: inline-block;
        border-left: 1px solid #6a7584;
        position: absolute;
        left: 50%;
        width: 1px;
        height: 100%;
        margin-left: -1px;

        &::before {
          content: " ";
        }
      }

      &:last-child .every-axis {
        display: none;
      }
    }
  }

  .rc-slider {
    position: absolute;
    width: 100%;
    bottom: 0;
    background: none;
    border-radius: 0;
    padding: 0;
    height: 8px;
    touch-action: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    * {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    .rc-slider-handle {
      position: absolute;
      background: transparent;
      margin-top: 0;
      margin-left: -20px;
      border-radius: 0;
      border: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      z-index: 103;
      width: 42px;
      height: 28px;
      top: -2px;
      // pointer-events: none;
      cursor: -webkit-grab;
      cursor: grab;
      cursor: pointer;
      touch-action: pan-x;
      filter: none !important;
      -webkit-clip-path: polygon(
        100% 0,
        100% 25%,
        55% 100%,
        45% 100%,
        0 25%,
        0 0
      );
      clip-path: polygon(100% 0, 100% 25%, 55% 100%, 45% 100%, 0 25%, 0 0);
    }
  }
}

.timeline-container {
  position: relative;
  height: 30px;
  overflow: visible;
}

.timeline-flags {
  position: relative;
  height: 40px;
}

.time-line-button {
  margin: 25px 0 0 2px;

  * {
    outline: none;
  }

  i {
    display: flex;
    width: 22px;
    height: 14px;
    color: #424f61;
    line-height: 15px;
    font-size: 14px;
    font-style: inherit;
    font-weight: bold;
    text-align: center;
    background-color: #b4b8d4;
    justify-content: center;
    cursor: pointer;

    &:first-child {
      border-top-right-radius: 5px;
      margin-bottom: 2px;
    }

    &:last-child {
      border-bottom-right-radius: 5px;
    }
  }
}

.time-line-help {
  position: absolute;
  top: 102px;
  left: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  background-color: #474261;
  border-radius: 50%;
  cursor: pointer;

  & > * {
    color: #fff;
    text-decoration: none;
  }
}

.support-staff {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(124,124,124,0.1200);
  border-radius: 50%;
  &>.icon {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/unclassified/support-staff.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  &:hover>.icon {
    background-image: url(../../assets/unclassified/support-staff-active.png);
    cursor: pointer;
  }
}

.qrCode {
  // position: absolute;
  // bottom: calc(100% + 12px);
  // left: 50%;
  // margin-left: -56px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 126px;
  width: 112px;
  border-radius: 8px;
  background: white;
  box-shadow: 4px 8px 7px 2px #afafaf;
  display: flex;
  &:hover {
    display: flex;
  }
  .word {
    font-size: 10px;
    font-weight: bold;
    color: #3d3d3d;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 87px;
    height: 87px;
    background: url(../../../static/img/codeBack.13ab4ed.png);
    background-size: contain;
    margin-top: 5px;
  }

  .content-img {
    height: 75px;
  }
}

.support-staff:hover {
  position: relative;
  .qrCode {
    display: flex;
  }
}
</style>

<style lang="scss">
.el-popover.el-popper.staff-popover {
  // display: flex !important;;
  justify-content: center !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tool/timeline.vue